import moment from 'moment';

export const formatSubmittedDate = (date) => {
	if (!date) return '----';
	return `${new Date(date).toLocaleDateString('en-US')} ${new Date(date).toLocaleTimeString('en-US', {
		hour: '2-digit',
		minute: '2-digit',
	})} (CDT)`;
};

export const formatLastEditedDate = (lastEditedDate, submittedDate) => {
	if (lastEditedDate === '') {
		return submittedDate !== '' ? 'Incomplete' : '----';
	}

	if (submittedDate !== '' && moment(submittedDate).diff(moment(lastEditedDate)) < 0) {
		return `${new Date(lastEditedDate).toLocaleDateString('en-US')} ${new Date(lastEditedDate).toLocaleTimeString('en-US', {
			hour: '2-digit',
			minute: '2-digit',
		})} (CDT)`;
	}
	return '----';
};

export const isApplicationRestricted = application => {
	return !(application?.jobOpeningStatusID === 1) || (application?.jobOpeningStatusID === 1 && !application?.isAccessible);
};